import Vue from 'vue';

// Require in a base component context
const requireComponent = require.context('./', true, /\.vue$/i);

requireComponent.keys().forEach((fileName) => {
  // Get component config
  const componentConfig = requireComponent(fileName);

  // Get PascalCase name of component
  const originalName = fileName.replace(/.vue/, '').split('/');
  const componentName = originalName[originalName.length - 1].replace(
    /.vue/,
    ''
  );

  // Register component globally
  return Vue.component(
    componentName,
    componentConfig.default || componentConfig
  );
});
